import InteractiveModal from './interactiveModal'

export default InteractiveModal
